"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var staticComponentSizesConfig = {
  mobile_appbar_height: 50,
  desktop_appbar_height: 80,
  notificationBoxHeight: 40,
  content_max_width: 1100
};
var _default = exports.default = staticComponentSizesConfig;